// React
import React from "react";

// Next
import Script from "next/script";

type SchemaScriptProps = {
    ldJson?: Record<string, any> | null;
};

const SchemaScript: React.FC<SchemaScriptProps> = ({ldJson}) => {
    if (!ldJson) {
        return null;
    }

    return <Script id={"schema-script"} type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(ldJson)}} strategy={"beforeInteractive"}/>
};

export default SchemaScript;
